import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto' }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      <p>
        This website collects and uses personal information only as necessary to provide the services
        and features offered on the site. We respect your privacy and comply with applicable data
        protection laws. We use third-party services such as Google AdSense which may collect
        information for advertising purposes. These services have their own privacy policies and
        practices. By using this site you agree to the use of cookies and similar technologies for
        analytics and advertising. For any questions, contact: <a href="mailto:support@pdfblink.com">support@pdfblink.com</a>.
      </p>
      <h2>Third-party services</h2>
      <p>
        We may use third-party analytics and advertising providers (for example, Google Analytics
        and Google AdSense). Those providers may collect information about your visit and set
        cookies. Please review their privacy policies for more information.
      </p>
      <h2>Changes</h2>
      <p>We may update this policy from time to time. The date at the top indicates when it was last updated.</p>
    </div>
  );
};

export default PrivacyPolicy;
